<template>
    <div class="d-flex justify-content-center flex-wrap p-4">
        <div class="col-12 col-md-8">
            <IFrame @decoded_res="decoded_res"/>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import IFrame from '@/components/IFrame.vue'
export default {
    name: 'AddBankCards',
    components : {
        IFrame
    },
    computed: {
        ...mapState(['account']),
        ...mapGetters(['apiPath', 'omsApiPath', 'omsApiKey']),
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        async decoded_res(decoded_res) {
            var short_id = null
            var pan_short_id = null
            var payment_account_reference = null

            if (decoded_res) {
                short_id = decoded_res.tokens[0]
                pan_short_id = decoded_res.pan_token
                payment_account_reference = decoded_res.payment_account_reference
            }
            
            try {
                const response = await this.$http.get(`${this.omsApiPath}/bank_cards/get/${this.omsApiKey}///${short_id ?? ''}/${pan_short_id ?? ''}/${payment_account_reference ?? ''}`)

                if (response.data.payload.length > 0) {
                    try {
                        const res = await this.$http.post(`${this.apiPath}/bank_cards/add`, { 
                            bank_card: response.data.payload[0],
                            accounts_id: this.account.id
                        }, { 
                            headers: {
                                'x-api-key': this.omsApiKey
                            }
                        })

                        switch (res.data) {
                            case 'Bank Card Already Added':
                                this.$toast.info(`<h3>${this.$t('Dashboard.AddBankCards.Modals.tokenizer_response.already_added')}</h3> <h5>${response.data.payload[0].truncated_pan}</h5>`)
                                break
                            default:
                                this.$toast.success(`<h3>${this.$t('Dashboard.AddBankCards.Modals.tokenizer_response.succeeded')}</h3> <h5>${response.data.payload[0].truncated_pan}</h5>`)
                                break
                        }
                    } catch (err) {
                        this.setErrorFromServer(err.message)
                    }
                } else {
                    this.$toast.info(`<h4>${this.$t('Dashboard.AddBankCards.Modals.tokenizer_response.unused')}</h4>`)
                }
                this.$router.replace('/dashboard/travels/bank_cards')
            } catch (err) {
                this.setErrorFromServer(err.message)
            }
        }
    }
}
</script>